import { render, staticRenderFns } from "./AtencaoPrimariaSaudeComponente.vue?vue&type=template&id=e9b0e088"
import script from "./AtencaoPrimariaSaudeComponente.vue?vue&type=script&lang=js"
export * from "./AtencaoPrimariaSaudeComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports